import SectionHeading from "./SectionHeading";
import { collections } from "@/mocks/home";

const badgeTint: Record<string, string> = {
  "本周主推": "bg-primary-500 text-background-50",
  "热度上升": "bg-accent-500 text-secondary-950",
  "广受关注": "bg-accent-500 text-secondary-950",
  "持续跟进": "bg-secondary-500 text-background-50",
  "话题热门": "bg-primary-500 text-background-50",
  "常被查阅": "bg-secondary-500 text-background-50",
};

export default function CollectionSection() {
  return (
    <section id="collections" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <SectionHeading
          id="collections"
          kicker="合集索引"
          title="热门黑料合集，大图卡片流"
          desc="封面驱动的合集卡片，每张都写清楚收录了什么、更新到哪一天，点进去就能按主题一次性看完关键材料。"
          actionLabel="查看全部合集"
          actionHref="#archive"
          actionIcon="ri-archive-2-line"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {collections.map((item) => (
            <article
              key={item.id}
              className="hover-lift group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面图`}
                  title={`${item.title} 黑料bu黑料合集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-full px-2.5 py-1 font-label text-[11px] font-medium ${
                    badgeTint[item.badge] ?? "bg-foreground-950 text-background-50"
                  }`}
                >
                  {item.badge}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <div className="mb-3 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                  <a href="#archive" className="cursor-pointer hover:text-primary-700">
                    {item.title}
                  </a>
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-xs leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4">
                  <span className="font-label text-xs text-foreground-500">
                    {item.entries} 份材料 · {item.updated}
                  </span>
                  <a
                    href="#archive"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-50 px-3 py-1.5 font-label text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100"
                  >
                    <i className="ri-folder-open-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    查阅
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}